(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mapa-tiendas"]) return;
  try {
    
  defer(function () {
    $(document).ready(function() {
      var winW = $(window).width();
      if (winW > 991) {
        $(window).load(function() {
          let map_height = window.innerHeight - ($('.barra').outerHeight() + $('header').outerHeight() + $('.infobar').outerHeight());
          $('#map').css('height', map_height);
        });

        $(window).scroll(function() {
          let map_height = window.innerHeight - ($('.barra').outerHeight() + $('header').outerHeight() + $('.infobar').outerHeight());
          $('#map').css('height', map_height);
        });
      }
    });
  }, 0);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  // Esta función se ejecutará cuando el documento esté listo
  $(document).ready(function() {
    // Llama a la función para formatear los números
    formatNumbers();

    // Llama a la función para actualizar el carrito
    //updateMiniCart();
  });

  // Función para formatear los números con comas y decimales
  function formatNumbers() {
    $('.cifra').text(function(_, text) {
      // Dividir el texto en parte entera y parte decimal
      var parts = text.split('.');
      var integerPart = parts[0];
      var decimalPart = parts.length > 1 ? '.' + parts[1] : '';
      
      // Agregar comas como separadores de miles a la parte entera
      integerPart = integerPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

      // Devolver el número formateado con decimales
      return integerPart + decimalPart;
    });
  }

  // Función para actualizar el contenido del carrito
function updateMiniCart() {
  // Aquí puedes colocar la lógica para actualizar el contenido del mini carrito
  // Por ejemplo, puedes usar jQuery para realizar una solicitud AJAX al servidor
  // y obtener la información actualizada del carrito de compras.
  // Luego, actualiza los elementos HTML del mini carrito con los nuevos datos.
  
  $.ajax({
    url: '/actualizar_carrito', // URL para actualizar el carrito (debe ser reemplazada con la URL real)
    type: 'GET',
    success: function(data) {
      // Manejar la respuesta del servidor
      // Actualizar los elementos HTML del mini carrito con los nuevos datos
    },
    error: function(xhr, status, error) {
      // Manejar errores de la solicitud AJAX
      console.error('Error al actualizar el carrito:', error);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notificaciones"]) return;
  try {
    
  document.querySelector(".cerrar-noti").addEventListener("click", (e) => {
    document.querySelectorAll(".noti").forEach(box => { box.style.display = "none" })
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              var observer = lozad(); // lazy loads elements with default selector as '.lozad'
              observer.observe();
              quantity_elements(true);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
